"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import type { ModelsMediaCard } from "../../../types";
import { MediaCard } from "../../common/media-card";
import { CarouselButton } from "../../common/carousel-button";
import NextLink from "next/link";
export interface ValueArticleCategoryCarouselSwiperProps {
  swiperClassName?: string;
  navClassName?: string;
  swiperSliderClassName?: string;
  sectionName: string;
  cards: ModelsMediaCard[];
}

function ValueArticleCategoryCarouselSwiper({
  swiperClassName,
  navClassName,
  swiperSliderClassName,
  cards,
  sectionName,
}: ValueArticleCategoryCarouselSwiperProps) {
  const swiperId = "value-article-category-cards";

  return (
    <>
      <Swiper
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          720: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 1,
            spaceBetween: 32,
          },
        }}
        modules={[Navigation]}
        navigation={{
          prevEl: `.prev-carousel-${swiperId}`,
          nextEl: `.next-carousel-${swiperId}`,
        }}
        simulateTouch={false}
        slidesPerView={3}
        spaceBetween={32}
        className={swiperClassName}
        loop={true}
      >
        {cards.map((card) => (
          <SwiperSlide
            className={swiperSliderClassName}
            key={`card-${card.id}`}
          >
            <MediaCard
              data={card}
              theme={"dark"}
              sectionName={sectionName}
              layout="compact"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <nav className={navClassName} id={swiperId}>
        <CarouselButton
          className={`prev-carousel-${swiperId} ml-[-36px] pointer-events-auto`}
          startIcon="arrow-left"
        />
        <CarouselButton
          className={`next-carousel-${swiperId} mr-[-36px] pointer-events-auto`}
          startIcon="arrow-right"
        />
      </nav>
    </>
  );
}

export default ValueArticleCategoryCarouselSwiper;
